import { createListenerMiddleware, TypedStartListening } from '@reduxjs/toolkit';
import { notification } from 'antd';
import {AppDispatch, RootState} from "../../store";
import {pollOperationStatus} from "./operationsThunks";
import {fetchDocumentDetails} from "../documents/documentsThunks";
import {fetchPropertyDetails} from "../documents/propertiesThunks";
import { fetchDocumentsBySet } from "../../slices/documentSetSlice";

export const operationListenerMiddleware = createListenerMiddleware();

export const startAppListening = operationListenerMiddleware.startListening as TypedStartListening<RootState, AppDispatch>;

// Регистрируем слушателя, который реагирует на успешное завершение polling-операции.
startAppListening({
    actionCreator: pollOperationStatus.fulfilled,
    effect: async (action, listenerApi) => {
        const state = listenerApi.getState() as RootState;
        const op = state.operations.operations[action.payload.id];
        const opMeta = state.operations.meta[action.payload.id];

        // Если операция завершена успешно, реагируем в зависимости от её типа
        if (op.status === 'Completed') {
            switch (op.type) {
                case 'CREATE_DOCUMENT': {
                    const docId = opMeta.documentId;
                    if (docId) {
                        listenerApi.dispatch(fetchDocumentDetails(docId));
                    }
                    const { currentSet, ownerId } = (listenerApi.getState() as RootState).documentSet;
                    listenerApi.dispatch(fetchDocumentsBySet({ setType: currentSet, ownerId: ownerId ?? undefined }));
                    break;
                }
                case 'CREATE_PROPERTY':
                case 'UPDATE_PROPERTY': {
                    const propertyId = opMeta.propertyId;
                    if (propertyId) {
                        // После создания или обновления свойства загружаем его данные
                        listenerApi.dispatch(fetchPropertyDetails(propertyId));
                    }
                    break;
                }
                default:
                    break;
            }
        } else if (op.status === 'Failed') {
            // Если операция завершилась неудачно, показываем уведомление с сообщением об ошибке
            notification.error({
                message: 'Операция завершилась с ошибкой',
                description: op.errorMessage || 'Произошла неизвестная ошибка.',
            });
        }
    },
});
